    export interface IMarketCap {
        marketId: number;
        marketCapId: number;
        annualProductionCap: number;
        systemSizeCap: number;
        yieldCap: number;
    }

    export class MarketCap implements IMarketCap {
        marketId: number;
        marketCapId: number;
        annualProductionCap: number;
        systemSizeCap: number;
        yieldCap: number;
    }